import React from 'react'

export const WishList = () => {
  return (
    <div>WishList</div>
  )
}
